import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { LoadViewModel } from '../models/load-view-model';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getLoads(includeInactive: boolean = false, includeBins = false, date: Date, loadNumber: string, cropYearId: number = undefined) {

    let queryParameters = new HttpParams();

    if (includeBins !== undefined && includeBins !== null) {
      queryParameters = queryParameters.set('includeBins', <any>includeBins);
    }

    if (cropYearId !== undefined && cropYearId !== null) {
      queryParameters = queryParameters.set('cropYearId', cropYearId.toString());
    }


    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }

    if (date) {
      queryParameters = queryParameters.set('receiptDate', date.toISOString());
    }

    if (loadNumber) {
      queryParameters = queryParameters.set('loadNumber', loadNumber);
    }


    return this.httpClient.get<LoadViewModel[]>(`${this.basePath}/api/loads`,
      {
        params: queryParameters,
      }
    );
  }

  public getLoadsForStemilt(includeInactive: boolean = false, includeBins = false, date: Date, loadNumber: string, cropYearId: number = undefined) {

    let queryParameters = new HttpParams();

    if (includeBins !== undefined && includeBins !== null) {
      queryParameters = queryParameters.set('includeBins', <any>includeBins);
    }

    if (cropYearId !== undefined && cropYearId !== null) {
      queryParameters = queryParameters.set('cropYearId', cropYearId.toString());
    }


    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }

    if (date) {
      queryParameters = queryParameters.set('receiptDate', date.toISOString());
    }

    if (loadNumber) {
      queryParameters = queryParameters.set('loadNumber', loadNumber);
    }

    return this.httpClient.get<LoadViewModel[]>(`${this.basePath}/api/loads/loadsForStemilt`,
      {
        params: queryParameters
      }
    );
  }

  public getLoad(loadId: number): Observable<LoadViewModel> {
    return this.httpClient.get<LoadViewModel>(`${this.basePath}/api/loads/${loadId}`);
  }

  public getLoadByBinBarcode(barcode: string): Observable<LoadViewModel> {
    return this.httpClient.get<LoadViewModel>(`${this.basePath}/api/loads/bybinbarcode/${barcode}`);
  }

  public postLoad(load: LoadViewModel, printTags: boolean = null, printerId: number = null): Observable<LoadViewModel> {

    let queryParameters = new HttpParams();

    if (printTags !== null) {
      queryParameters = queryParameters.set('printTags', printTags.toString());
    }

    if (printerId !== null) {
      queryParameters = queryParameters.set('printerId', printerId.toString());
    }

    return this.httpClient.post<LoadViewModel>(`${this.basePath}/api/loads`, load,
      {
        params: queryParameters
      }
    );
  }

  public notifyIntegration(loadId: number): Observable<any> {
    return this.httpClient.post<LoadViewModel>(`${this.basePath}/api/loads/notify?loadId=${loadId.toString()}`, null);
  }

  public printTag(loadId: number, printerId: number): Observable<LoadViewModel> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('id', <any>loadId);
    queryParameters = queryParameters.set('printerId', <any>printerId);

    return this.httpClient.put<LoadViewModel>(`${this.basePath}/api/loads/print`, null,
      {
        params: queryParameters
      }
    );
  }

  public putLoadDTO(load: LoadViewModel): Observable<LoadViewModel> {
    return this.httpClient.put<LoadViewModel>(`${this.basePath}/api/loads/${load.id}`, load);
  }

  public deleteLoad(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/loads/${id}`);
  }

  public getCropTrackerSizeData(referenceNumbers: string[]): Observable<any> {
    return this.httpClient.post(`${this.basePath}/api/croptracker/getSizeReport`, referenceNumbers);
  }

  public getQCSummaryForStemilt(): Observable<any> {
    return this.httpClient.get(`${this.basePath}/api/qc/summary/stemilt`);
  }

  public getCropTrackerSizeDataV2(referenceNumbers: string[]): Observable<any> {
    return this.httpClient.post(`${this.basePath}/api/croptracker/getSizeReportV2`, referenceNumbers);
  }

  public getFilteredLoads(cropYearId?: number, varietyId?: number, roomId?: number, customerId?: number): Observable<any> {
    let queryParameters = new HttpParams();

    if (cropYearId !== undefined && cropYearId !== null) {
      queryParameters = queryParameters.set('cropYearId', cropYearId.toString());
    }

    if (varietyId !== undefined && varietyId !== null) {
      queryParameters = queryParameters.set('varietyId', varietyId.toString());
    }

    if (roomId !== undefined && roomId !== null) {
      queryParameters = queryParameters.set('roomId', roomId.toString());
    }

    if (customerId !== undefined && customerId !== null) {
      queryParameters = queryParameters.set('customerId', customerId.toString());
    }

    return this.httpClient.get<any[]>(`${this.basePath}/api/loads/filtered`,
      {
        params: queryParameters
      }
    );
  }
}
